import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import AdelaidaPortrait, { framesForVoice } from "@/components/AdelaidaPortrait";
import { useAuth } from "@/context/AuthContext";
import { useOrbVoice } from "@/lib/orbVoice";
import { Volume2 } from "lucide-react";

// The human Coach appears with one short spoken line (once per morning / evening).
export default function CoachCheckIn({ line, walkthrough, spoken, speak, playKey, part }) {
  const { user } = useAuth();
  const voice = user?.voice || "sage";
  const { amplitudeRef, speak: say, stop } = useOrbVoice(voice, "routine");
  const speakingRef = useRef(false);
  const [talking, setTalking] = useState(false);
  const hear = async () => { speakingRef.current = true; setTalking(true); await say(spoken || line); speakingRef.current = false; setTalking(false); };
  useEffect(() => { if (line && (speak || playKey)) hear(); return () => stop(); }, [line, speak, playKey]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!line) return null;
  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
      className="flex items-center gap-5 mb-10" data-testid="routine-coach">
      <button onClick={hear} aria-label="Hear your Coach" data-testid="routine-coach-portrait"
        className={`relative w-24 h-24 sm:w-28 sm:h-28 rounded-full overflow-hidden shrink-0 ring-1 transition-shadow duration-700 ${talking ? "ring-primary/60 shadow-[0_0_40px_rgba(120,170,230,0.35)]" : "ring-white/10"}`}>
        <AdelaidaPortrait amplitudeRef={amplitudeRef} speakingRef={speakingRef} frames={framesForVoice(voice)} status={talking ? "speaking" : "idle"} />
      </button>
      <div className="min-w-0">
        <p className="text-[11px] uppercase tracking-[0.22em] text-primary mb-2">{part === "evening" ? "Evening" : "Today"} with your Coach</p>
        <p className="font-serif text-xl sm:text-2xl leading-snug" data-testid="routine-coach-line">{line}</p>
        {walkthrough && <p className="text-sm text-muted-foreground leading-relaxed mt-2" data-testid="routine-coach-walkthrough">{walkthrough}</p>}
        {!talking && <button onClick={hear} className="mt-2 text-xs text-muted-foreground hover:text-foreground flex items-center gap-1 transition-colors" data-testid="routine-coach-hear"><Volume2 className="w-3.5 h-3.5" /> Hear it</button>}
      </div>
    </motion.div>
  );
}
